<!--Accordion Starts-->
<section id="accordion">
  <div class="row text-left">
    <div class="col-sm-12">
      <div class="content-header">Accordion</div>
      <p class="content-sub-header"></p>
    </div>
  </div>
  <div class="row text-left">
    <div class="col-md-12 col-lg-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Collapsible Accordion</h4>
        </div>
        <!--Collapsible Accordion Starts-->
        <div class="card-body">
          <ngb-accordion #acc="ngbAccordion" activeIds="ngb-panel-0">
            <ngb-panel title="Simple">
              <ng-template ngbPanelContent>
                <p class="m-0">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf
                  moon officia aute,
                  non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
                  tempor,
                  sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim
                  keffiyeh
                  helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
                  vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably
                  haven't
                  heard of them accusamus labore sustainable VHS.</p>
              </ng-template>
            </ngb-panel>
            <ngb-panel>
              <ng-template ngbPanelTitle>
                <span>&#9733; <b>Fancy</b> title &#9733;</span>
              </ng-template>
              <ng-template ngbPanelContent>
                <p class="m-0">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf
                  moon officia aute,
                  non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
                  tempor,
                  sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim
                  keffiyeh
                  helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
                  vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably
                  haven't
                  heard of them accusamus labore sustainable VHS.</p>
              </ng-template>
            </ngb-panel>
            <ngb-panel title="Disabled" [disabled]="true">
              <ng-template ngbPanelContent>
                <p class="m-0">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf
                  moon officia aute,
                  non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
                  tempor,
                  sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim
                  keffiyeh
                  helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
                  vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably
                  haven't
                  heard of them accusamus labore sustainable VHS.</p>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
        </div>
      </div>
      <!--Collapsible Accordion Ends-->
    </div>
    <div class="col-md-12 col-lg-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">One open panel at a time</h4>
        </div>
        <div class="card-body">
          <!--One open panel at a time Starts-->
          <ngb-accordion [closeOthers]="true" activeIds="1">
            <ngb-panel id="static-1" title="Simple">
              <ng-template ngbPanelContent>
                <p class="m-0">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf
                  moon officia aute,
                  non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
                  tempor,
                  sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim
                  keffiyeh
                  helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
                  vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably
                  haven't
                  heard of them accusamus labore sustainable VHS.</p>
              </ng-template>
            </ngb-panel>
            <ngb-panel id="static-2">
              <ng-template ngbPanelTitle>
                <span>&#9733; <b>Fancy</b> title &#9733;</span>
              </ng-template>
              <ng-template ngbPanelContent>
                <p class="m-0">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf
                  moon officia aute,
                  non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
                  tempor,
                  sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim
                  keffiyeh
                  helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
                  vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably
                  haven't
                  heard of them accusamus labore sustainable VHS.</p>
              </ng-template>
            </ngb-panel>
            <ngb-panel id="static-3" title="Disabled" [disabled]="true">
              <ng-template ngbPanelContent>
                <p class="m-0">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf
                  moon officia aute,
                  non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
                  tempor,
                  sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim
                  keffiyeh
                  helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
                  vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably
                  haven't
                  heard of them accusamus labore sustainable VHS.</p>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
          <!--One open panel at a time Ends-->
        </div>
      </div>
    </div>
  </div>
  <div class="row text-left">
    <div class="col-md-12 col-lg-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Toggle panels</h4>
        </div>
        <div class="card-body">
          <!--Toggle panels Starts-->
          <ngb-accordion #tacc="ngbAccordion">
            <ngb-panel id="toggle-1" title="First panel">
              <ng-template ngbPanelContent>
                <p class="m-0">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf
                  moon officia aute,
                  non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
                  tempor,
                  sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim
                  keffiyeh
                  helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
                  vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably
                  haven't
                  heard of them accusamus labore sustainable VHS.</p>
              </ng-template>
            </ngb-panel>
            <ngb-panel id="toggle-2" title="Second">
              <ng-template ngbPanelContent>
                <p class="m-0">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf
                  moon officia aute,
                  non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
                  tempor,
                  sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim
                  keffiyeh
                  helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
                  vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably
                  haven't
                  heard of them accusamus labore sustainable VHS.</p>
              </ng-template>
            </ngb-panel>
            <ngb-panel title="Disabled" [disabled]="true">
              <ng-template ngbPanelContent>
                <p class="m-0">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf
                  moon officia aute,
                  non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
                  tempor,
                  sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim
                  keffiyeh
                  helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
                  vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably
                  haven't
                  heard of them accusamus labore sustainable VHS.</p>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
          <p class="mt-3 mb-0">
            <button class="btn btn-secondary mr-2" (click)="tacc.toggle('toggle-1')">Toggle first</button>
            <button class="btn btn-secondary" (click)="tacc.toggle('toggle-2')">Toggle second</button>
          </p>
          <!--Toggle panels Ends-->
        </div>
      </div>
    </div>
    <div class="col-md-12 col-lg-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Prevent panel toggle</h4>
        </div>
        <div class="card-body">
          <!--Prevent panel toggle starts-->
          <ngb-accordion (panelChange)="beforeChange($event)">
            <ngb-panel id="preventchange-1" title="Simple">
              <ng-template ngbPanelContent>
                <p class="m-0">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf
                  moon officia aute,
                  non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
                  tempor,
                  sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim
                  keffiyeh
                  helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
                  vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably
                  haven't
                  heard of them accusamus labore sustainable VHS.</p>
              </ng-template>
            </ngb-panel>
            <ngb-panel id="preventchange-2" title="I can't be toggled...">
              <ng-template ngbPanelContent>
                <p class="m-0">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf
                  moon officia aute,
                  non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
                  tempor,
                  sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim
                  keffiyeh
                  helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
                  vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably
                  haven't
                  heard of them accusamus labore sustainable VHS.</p>
              </ng-template>
            </ngb-panel>
            <ngb-panel id="preventchange-3" title="I can be opened, but not closed...">
              <ng-template ngbPanelContent>
                <p class="m-0">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf
                  moon officia aute,
                  non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
                  tempor,
                  sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim
                  keffiyeh
                  helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
                  vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably
                  haven't
                  heard of them accusamus labore sustainable VHS.</p>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
          <!--Prevent panel toggle ends-->
        </div>
      </div>
    </div>
  </div>
</section>
<!--Accordion Ends-->
